<template>
    <div class="eval" id="eval">
       <!-- 我的测评 -->
       <div class="content">
         <div v-if="status == 1">
           <div class="icon">
             <img src="../../assets/images/eval_true.png" alt="">
           </div>
           <p class="title">已完成所有课程的学习，可以进行结业测评</p>
           <p class="intro"><span>题数：{{eventConfig.questionNum}}个</span><span>总分值：100分</span><span>答题时长：{{eventConfig.examDuration}}分钟</span>
             <span>尝试次数：{{eventConfig.examLimit}}次</span><span>及格分数：{{eventConfig.pass}}分</span></p>
           <p class="num">剩余尝试次数：<span class="number">{{eventConfig.remainingTime}}</span>次
             <span class="place"> </span>分数：<span class="number">{{eventConfig.maxExam}}</span>分
             <span v-if="eventConfig.status==1" class="status">（已通过）</span><span v-if="eventConfig.status==0" class="status">（未通过）</span></p>
           <div v-if="eventConfig.remainingTime!=0" class="btn" @click="toEval">开始测评</div>
         </div>
         <div v-if="status == 0">
           <div class="icon">
             <img src="../../assets/images/eval_false.png" alt="">
           </div>
          <p class="title">还有课程未完成！</p>
          <p class="title">请先完成课程学习后，再参加结业测评</p>
           <div class="btn" @click="toStudy" style="margin-top: 1.5rem;">去学习</div>
         </div>
       </div>
       <div class="masking">

       </div>
    </div>
</template>

<script>
  export default {
    name: 'eval',
    data () {
      return {
        status:0,
        eventConfig:{}
      }
    },
    mounted() {
      this.event = JSON.parse(localStorage.getItem('event'));
      console.log(this.enent);
      this.getStatus();
    },
    methods:{
      toEval(){
        this.$router.push('./AfterTest');
      },
      toStudy(){
        this.$router.push('./Course');
      },
      getStatus(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
        }
        this.post('/exam/examDetail',params,(data)=>{
          console.log(data);
          if(data.status == 200){
            _this.status = 1;
            _this.eventConfig=data.data
          }else{
            _this.status = 0;
          }
        })
      },
    }
  }
</script>
<style scoped>
.content{
  width: 15rem;
  margin: 0 auto;
  padding-bottom: 0.84rem;
}
.icon{
  width: 1.35rem;
  height: 1.35rem;
  margin: 01rem auto 0.5rem auto;
}
.icon img{
  width: 100%;
  height: 100%;
  float: left;
}
p{
  text-align: center;
}
.title{
  font-size: 0.42rem;
  color: #404040;
  margin-bottom: 0.27rem;
}
.intro{
  font-size: 0.25rem;
  color: #838383;
  margin-bottom: 0.7rem;
}
.intro span{
  margin-right: 0.3rem;
}
.num{
  font-size: 0.35rem;
  color: #404040;
  margin-bottom: 0.7rem;
}
.num .nmber{
  font-size: 0.42rem;
}
.num .status{
  color: #00cf05;
}
.num .place{
  margin-left: 1rem;
}
.btn{
  width: 2.52rem;
  height: 0.83rem;
  margin: 0 auto;
  background-color: #0073d3;
  color: #fff;
  font-size: 0.34rem;
  text-align: center;
  line-height: 0.84rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/index/Eval.vue